import angular from 'angular';
import inputCurrency from './inputCurrency';

export default angular
  .module('components.inputCurrency', [])
  .component('inputCurrency', inputCurrency).name;
